(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sr-password-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const panel = document.getElementById('contact');
    if (!panel) return;
    const heading = document.getElementById('sr-contact-title');
    const link = document.querySelector('.sr-password-contact-link a');
    let wasOpen = false;
    const update = () => {
      const open = location.hash === '#contact';
      if (open) {
        const result = panel.querySelector('[data-sr-contact-result]');
        (result || heading).focus({ preventScroll: true });
        window.scrollTo(0, 0);
      } else if (wasOpen) {
        link.focus({ preventScroll: true });
      }
      wasOpen = open;
    };
    if (panel.querySelector('[data-sr-contact-result]') || location.hash === '#SrPasswordContactForm') {
      history.replaceState(null, '', location.pathname + location.search + '#contact');
    }
    window.addEventListener('hashchange', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
